import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'valueToLabel'})

export class ValueToLabelPipe implements PipeTransform {

	constructor() {

	}

	transform(value: string, options: any[]): string {
		if (!options || !options.length) {
			return value;
		}
		const option = options.find(o => o.value === value);

		if (!option || !option.label) {
			return value;
		}
		return option.label;
	}
}
